import { Component, OnInit } from '@angular/core';
import { MainService } from '../../../services/main/main.service';
import { AuthService } from '../../../services/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import * as Regex from '../../../shared/regex'
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { SharedService } from 'src/app/services/shared/shared.service';
import { CanonicalService } from 'src/app/services/canonical.service';
import { Meta } from '@angular/platform-browser';
import { ProfileComponent } from '../../profile/profile/profile.component';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { getUserProfile, setUserProfiles } from 'src/app/core/session';
// import { MatDialog } from '@angular/material';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  response;
  environment: any = localStorage.getItem('environment') || '';
  hideEnv: boolean = false;
  hidePwd: boolean;
  user = this.fb.group({
    email: ["", [Validators.required, Validators.maxLength(100)]],
    password: [""],
    otp: [""]
  });
  public business_url = environment.business_url;
  email_otp: any;
  changePanel: number = 0;
  resendTime: any = '02:59';
  time: any = null;
  constructor(
    private metaTagService: Meta,
    private canonicalService: CanonicalService,
    public mainService: MainService,
    public authService: AuthService,
    private router: Router,
    public _shared: SharedService,
    private fb: UntypedFormBuilder,
    private _activated: ActivatedRoute,
    public dialog: MatDialog,
    private _profileComponent: ProfileComponent) {
  }

  ngOnInit() {
    this.hidePwd = true;
    if (environment.production == true) {
      this.hideEnv = true;
      this.canonicalService.setCanonicalURL('https://business.denefits.com/login/');
      this.metaTagService.addTags([
        { name: 'title', content: 'Login to Your Business Panel - Denefits' },
        { name: 'description', content: 'Denefits business sign-in. Access your business information. Denefits - Complete Payment Options offers financing to all with No Credit Checks.' },
        { name: 'robots', content: 'index, follow' }
      ]);
    }
    if (localStorage.getItem('token')) {
      const returnUrl = this._activated.snapshot.queryParamMap.get('returnUrl')
        || sessionStorage.getItem('postLoginReturnUrl');
      if (returnUrl && returnUrl.startsWith('/app/') && !returnUrl.startsWith('//')) {
        sessionStorage.removeItem('postLoginReturnUrl');
        this.router.navigateByUrl(returnUrl);
      } else {
        this.router.navigate(['app/finance-customer']);
      }
    }
  }

  submitForm(form: any) {
    if (form.valid) {
      const data = {
        email: isNaN(form.value.email) ? form.value.email.replace(/\s/g, '').toLowerCase() : Number(form.value.email),
        password: this.mainService.encryptInMD5(form.value.password),
        device_type: environment.device_type,
        app_type: environment.app_type,
        app_version: environment.app_version,
        device_token: environment.device_token,
        device_id: localStorage.getItem('user')
      };

      this.authService.login(data)
        .subscribe((response: any) => {
          if (response.is_error == 1) {
            let error = response.override_text || response.err || "Email/Phone and Password doesn't match.";
            if (error) {
              error = error.replace('Username', 'Phone');
            }
            this.user.controls.password.setErrors({ password_null: (error) });
            this.user.controls.email.setErrors({ emial_phone_null: (error) });
            return;
          }
          localStorage.setItem('token', response.token);
          if (response.flag === 116) {
            localStorage.setItem('reset_password_token', response.reset_password_token);
            localStorage.setItem('reset_email', data.email);
            this.router.navigate(['new-password']);
            return
          } else if (response.is_error === 0) {
            this.mainService.clearPFData();
            this.mainService.init();
            localStorage.removeItem('pfPatientEmail');
            localStorage.removeItem('financePlans');
            localStorage.removeItem('financeSave');
            /*setting side menu once user logged in and got side menu data*/
            this.mainService.available_menu.next(response.menu);
            this.mainService.flagPopUps(response.flag, '');
            this.authService.setLoginData(response);
            setTimeout(() => {
              this.authService.accessTokenLogin();
            }, 0);
            // this._shared.clearLocalStorage();
            this._shared.clearLeadsData();
            setTimeout(()=>{
              this.instantPayoutPopup();
            },100);        
          } else if (response && response.menu && response.menu.length > 0) {
            this.mainService.flagPopUps('Menu not found! Redirecting to login page.', 2);
            return;
          } else {
            if (response.override_text || response.err) {
              this.mainService.customPopups(response.override_text || response.err, 1);
            } else {
              this.mainService.flagPopUps(response.flag, response.is_error);
            }
          }
        }, (error: any) => {
          console.log(error);
        });
    }
  }

  GenerateOtp() {
    if (this.user.controls.email.value.trim() == '') {
      this.user.controls.email.setErrors({ emial_phone_null: "Please enter a valid email/phone." });
      return;
    }
    if (!new RegExp(Regex.Email).test(this.user.controls.email.value.trim()) && isNaN(this.user.controls.email.value.trim())) {
      this.user.controls.email.setErrors({ emial_phone_null: 'Please enter a valid email/phone.' });
      return;
    }
    if (!new RegExp(Regex.mobile).test(this.user.controls.email.value.trim()) && !isNaN(this.user.controls.email.value.trim())) {
      this.user.controls.email.setErrors({ emial_phone_null: 'Phone number is not valid.' });
      return;
    }

    if (!isNaN(this.user.controls.email.value.trim())) {
      this.email_otp = "******" + this.user.controls.email.value.trim().slice(6, 10)
    }
    else {
      this.email_otp = this.user.controls.email.value.trim();
    }
    let data = {
      email: isNaN(this.user.controls.email.value.trim()) ? this.user.controls.email.value.trim() : Number(this.user.controls.email.value.trim())
    }
    this.mainService.api(data, 'send_login_otp', true).subscribe((data) => {
      if (data.is_error == 0) {
        this.changePanel = 2;
        this.user.controls.otp.setValue('')
        this.setResendTime()
      }
    })
  }

  passwordSignin() {
    if (this.user.controls.password.value === '') {
      this.user.controls.password.setErrors({ password_null: 'Please enter a valid password.' });
      return;
    }

    let form = {
      valid: true,
      value: {
        email: isNaN(this.user.controls.email.value.trim()) ? this.user.controls.email.value.trim() : Number(this.user.controls.email.value.trim()),
        password: this.user.controls.password.value,
      }
    }
    this.submitForm(form);
  }


  enterPassword_form() {
    this.mainService.email_value = this.user.controls.email.value
    if (this.user.controls.email.value.trim() == '') {
      this.user.controls.email.setErrors({ emial_phone_null: "Please enter a valid email/phone." });
      return;
    }
    if (!new RegExp(Regex.Email).test(this.user.controls.email.value.trim()) && isNaN(this.user.controls.email.value.trim())) {
      this.user.controls.email.setErrors({ emial_phone_null: 'Please enter a valid email/phone.' });
      return;
    }
    if (!new RegExp(Regex.mobile).test(this.user.controls.email.value.trim()) && !isNaN(this.user.controls.email.value.trim())) {
      this.user.controls.email.setErrors({ emial_phone_null: 'Phone number is not valid.' });
      return;
    }
    if (this.user.controls.email.invalid) {
      return;
    }
    this.changePanel = 1;
  }

  verifyOtp() {
    if (this.user.controls.otp.value == '') {
      this.user.controls.otp.setErrors({ emial_otp_none: 'Please enter OTP to verify' });
      return
    }

    let mobile = this.user.value.email;

      if(mobile && !isNaN(mobile)) {

        mobile = String(mobile).replace('+1-','')

      }


    const data = {
      otp: this.user.controls.otp.value,
      device_type: environment.device_type,
      app_type: environment.app_type,
      app_version: environment.app_version,
      device_token: environment.device_token,
      device_id: localStorage.getItem('user'),
      doctor_email: mobile
    };

    this.mainService.api(data, 'verify_login_otp', true).subscribe(async (response) => {
      if (response.is_error == 1) {
        this.user.controls.otp.setErrors({ emial_otp_none: response.err });
        return;
      }
      if (response.flag === 116) {
        localStorage.setItem('reset_password_token', response.reset_password_token);
        localStorage.setItem('reset_email', this.user.controls.email.value.trim());
        this.router.navigate(['new-password']);
        return;
      } else if (response.is_error === 0) {
        this.mainService.clearPFData();
        localStorage.removeItem('pfPatientEmail');
        localStorage.removeItem('financePlans');
        localStorage.removeItem('financeSave');
        if (response.profile) {
          setUserProfiles(response.profile);
        }
        if (response.doctor_profile) {
          setUserProfiles(response.doctor_profile);
        }
        this.mainService.available_menu.next(response.menu);
        this.mainService.flagPopUps(response.flag, '');
        this.authService.setLoginData(response);
        // this._shared.clearLocalStorage();
        this._profileComponent.getSubscriptionDetails();
        this.authService.accessTokenLogin();
        this._shared.clearLeadsData();
        setTimeout(()=>{
          this.instantPayoutPopup();
        },100);
      } else if (response && response.menu && response.menu.length > 0) {
        this.mainService.flagPopUps('Menu not found! Redirecting to login page.', 2);
        return;
      } else {
        if (response.override_text || response.err) {
          this.mainService.customPopups(response.override_text || response.err, 1);
        } else {
          this.mainService.flagPopUps(response.flag, response.is_error);
        }
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  setResendTime() {
    this.time = new Date(new Date().setMinutes(new Date().getMinutes() + 3));
    var x = setInterval(() => {
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = this.time - now;

      // Time calculations for days, hours, minutes and seconds

      var minutes = '0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();
      var seconds = Math.floor((distance % (1000 * 60)) / 1000).toString();
      seconds = seconds && seconds.toString().length == 1 ? '0' + seconds.toString() : seconds.toString()
      // Output the result in an element with id="demo"
      this.resendTime = minutes.toString() + ":" + seconds;

      // If the count down is over, write some text
      if (distance < 0) {
        this.time = 0;
        this.resendTime = "00:00";
        clearInterval(x);
      }
    }, 1000);
  }

  register () {
    if (this._activated && this._activated.snapshot && this._activated.snapshot.queryParamMap && this._activated.snapshot.queryParamMap.get('sp_id')) {
      let params = this._activated.snapshot.queryParamMap.get('sp_id');
      this.router.navigate(['register'],  { queryParams: { sp_id: params} });
    } else {
      this.router.navigate(['register']);
    }
  }

  instantPayoutPopup() {
    let instant_payout = getUserProfile().instant_payout_config;
  
    if (instant_payout && instant_payout.total_payout > 0 && instant_payout.show_payout == 1 && instant_payout.show_payout_option == 0) {
      const preloadImg = new Image();
      preloadImg.src = 'assets/img/png/instantPay_bg.png';
  
      preloadImg.decode().then(() => {
        this.dialog.closeAll();
        setTimeout(() => {
          this.dialog.open(SimpleDialogComponent, {
            width: '502px',
            // height: '516px',
            panelClass: 'simpleDialog',
            data: { 
              type: 945, 
              bgImage: 'assets/img/png/instantPay_bg.png' 
            }
          });
        }, 5000);
      }).catch((error) => {
        this.dialog.closeAll();
        console.error('Failed to preload and decode image:', error);
        setTimeout(() => {
          this.dialog.open(SimpleDialogComponent, {
            width: '502px',
            // height: '516px',
            panelClass: 'simpleDialog',
            data: { 
              type: 945,
              bgImage: 'assets/img/png/instantPay_bg.png' 
            }
          });
        }, 5000);
      });
    }
  }
  
}
